module.exports = __webpack_public_path__ + "static/media/cvo-street-glide-bronze-armor.7d9b5df3.png";